import { type MutationHookOptions, useMutation } from "@apollo/client";
import { DeleteTagsMutation } from "../graphql/mutations";
import type { DeleteTagsMutationType } from "@/types/graphql/partner.generated";

export const useDeleteTagsMutation = (
  options?: MutationHookOptions<DeleteTagsMutationType>
) => {
  return useMutation<DeleteTagsMutationType>(DeleteTagsMutation, options);
};
